import { Component, ElementRef, Input, OnChanges, OnInit, SimpleChanges, ViewChild } from '@angular/core';
import { AbstractControl, UntypedFormArray, UntypedFormGroup } from '@angular/forms';
import { PluginSetting } from 'src/app/services/dtos/pluginSetting';
import { B2BFormat, B2BFormatView } from 'src/app/services/enums/b2bFormat.enum';
import { FeaturesSwitch } from 'src/app/services/enums/featuresSwitch.enum';
import { RightsService } from 'src/app/services/rights.service';

@Component({
  selector: 'app-plugin-settings',
  templateUrl: './plugin-settings.component.html',
  styleUrls: ['./plugin-settings.component.scss'],
})
export class PluginSettingsComponent implements OnChanges, OnInit {

  @ViewChild('selectSearch', { static: false })
  public selectSearch!: ElementRef;

  @Input() public isInCustomerConfigurationMode!: boolean;
  @Input() public settings!: UntypedFormArray;
  @Input() public hasFormatSetting!: boolean;
  @Input() public formatSettingValue!: string | undefined;
  @Input() public settingsFormArrayName!: string;
  @Input() public files!: UntypedFormArray;
  @Input() public filesFormArrayName!: string;
  @Input() public formReference!: UntypedFormGroup;
  @Input() public settingsTitle!: string;
  @Input() public filesTitle!: string;
  @Input() public features !: FeaturesSwitch;

  public b2BFormatView: string[] = Object.keys(B2BFormatView)
  .filter(f => isNaN(Number(f[0])));

  public constructor(public accessService: RightsService) { }

  public get hasMaintainCustomers(): boolean {
    return this.accessService.canMaintainCustomers();
  }
  
  public get hasSetPluginsFlowOfCustomers(): boolean {
    return this.accessService.canSetPluginsFlowOfCustomers();
  }

  public ngOnInit(): void {
    if (!this.hasMaintainCustomers || !this.hasSetPluginsFlowOfCustomers) {
      this.settings.disable();
    }
  }

  public b2bFormatChanged(): void {
    this.settings.controls.forEach((control) => {
      if(control.get('settingType')?.value === 'Boolean')
      {
        if(control.get('value')?.value.toString() === 'false')
          control.get('value')?.setValue(false);
        else
          control.get('value')?.setValue(true);
      }
    });

    this.formatSettingValue = (this.settings.value as PluginSetting[]).find(x => x.settingType?.toLowerCase() === 'b2bformat')?.value;
  }

  public ngOnChanges(changes: SimpleChanges): void {
    if(changes)
      this.b2bFormatChanged();
  }

  public showSetting(control: AbstractControl): boolean {
    if (this.hasFormatSetting) {
      const formatDependency: string = control.get('formatDependency')?.value ?? '0';
      if (B2BFormat[+formatDependency] === B2BFormat[B2BFormat.all]
        || B2BFormat[+formatDependency] === this.formatSettingValue
        || this.formatSettingValue === B2BFormat[B2BFormat.all]) {
        return true;
      }
      else {
        return false;
      }
    }
    return true;
  }

  public compareEnum(option: string, selection: string): boolean {
    if (option.toLowerCase() === selection.toLowerCase()) {
      return true;
    }
    else { return false; }
  }

  public getSettingWidthClass(control: AbstractControl): string {
    const widthClass: string = control.get('columnsAmount')?.value ?? '0';
    return 'columns-' + widthClass;
  }

  public hasSupportForMappings(): boolean{
    // eslint-disable-next-line no-bitwise
    return FeaturesSwitch.customerMappings === (this.features & FeaturesSwitch.customerMappings) ;
  }

  public selectToggled(): void {
    if (this.selectSearch.nativeElement) {
      this.selectSearch.nativeElement.value = '';
    }
  }

  public isInFilter(
    value: string,
  ): boolean {
    const query = this.selectSearch.nativeElement.value;
    const allValues = this.settings?.controls?.find(x => x.value.key === 'PeppolIdentifier')?.value.typeValues;
    return allValues
      ?.filter((x: string) => x.toLowerCase().includes(query.toLowerCase()))
      .some((x: string) => x === value);
    }

  public getSelectionListValue(value: string, control: AbstractControl): string {
    if (control.value?.key === 'PeppolIdentifier') {
      const index = value.indexOf('-');
      // remove scheme
      const icdValue = value.slice(0, index - 1);
      return icdValue;
    }
    return value;
  }
}
